import * as Sentry from "@sentry/vue";
import { Plugin } from "vue";
import { useCurrentUser } from "../api/current-user";
import { __DEV__ } from "../constants";

function createSentry(): Plugin {
	return {
		install(app) {
			if (!__DEV__) {
				Sentry.init({
					app,
					dsn: "https://3ad093844e7142a8a43bf58d4dc1f8e6@o370388.ingest.sentry.io/5179796",
					integrations: [],
					ignoreErrors: ["ResizeObserver loop completed with undelivered notifications"],
				});
			}
		},
	};
}

export function provideSentryUser() {
	const { data: user } = useCurrentUser();

	whenever(user, (user) => {
		Sentry.setUser({
			id: user.id,
			username: user.auth.type === "username" ? user.auth.username : undefined,
			email: user.auth.type === "email" ? user.auth.email : undefined,
		});
	});
}

export function captureError(err: unknown) {
	Sentry.captureException(err);
}

export const sentry = createSentry();
